// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__i6R3_","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3OuDd","obliqueLine":"membershipbadge_obliqueLine__3zKE7"};